<template>
  <form id="cd-rate-calculator-form" class="form cd-rate-calculator-form floating-label container" v-on:submit.prevent="getCDRates()">
    <div :class="formInitial || recalculate ? 'cd-rate-calculator-form-single-column mt-md-5' : 'cd-rate-calculator-form-multi-column'">
      <div :class="formInitial || recalculate ? 'row' : 'row pt-md-5'">
        <div :class="formInitial || recalculate ? 'col-sm-12 col-md-12' : 'pr-md-5 pr-lg-5 col-sm-12 col-md-6 col-lg-6 w-print-lg'">
          <div :class="formInitial || recalculate ? 'row justify-content-center' : 'row'">
            <!-- Zip Input Field -->
            <div :class="formInitial || recalculate ? 'col-md-6 col-sm-12' : 'col-md-12 col-sm-12'">
              <div class="form-group mb-md-4">
                <div :class="zipcodeModel !== '' ? 'floating-label is-floating' : 'floating-label'">
                  <label for="zipcode-field">ZIP Code</label>
                  <input
                    ref="ziplocation"
                    id="zipcode-field"
                    placeholder=""
                    name="zipcode-field"
                    autocapitalize="off"
                    autocomplete="off"
                    spellcheck="false"
                    aria-label="LABEL HERE"
                    maxlength="5"
                    class="form-control cd-rate-zipcode-input"
                    @blur="toggleLabel($event)"
                    @focus="toggleLabel($event)"
                    @change="updateZipCode()"
                    v-model="zipcodeModel"
                    type="text"
                    @keypress="onlyNumber"
                    @keyup="clearInput()"
                  />
                  <div class="cd-rate-calculator-form__error-message" v-show="zipCodeLessThanFive">ZIP CODE IS REQUIRED.</div>
                  <div class="cd-rate-calculator-form__error-message" v-show="zipRangeCondition && !zipCodeLessThanFive">
                    THIS ZIP CODE IS NOT WITHIN OUR LOCATION AREA RANGE. PLEASE USE ANOTHER ZIP CODE.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div :class="formInitial || recalculate ? 'row justify-content-center' : 'row'">
            <!-- initial amount field -->
            <div :class="formInitial || recalculate ? 'col-md-6 col-sm-12' : 'col-md-12 col-sm-12'">
              <div class="form-group mb-md-4">
                <div :class="initialAmountModel ? 'floating-label is-floating' : 'floating-label'">
                  <label for="initial-amount-field">Initial Amount</label>
                  <input
                    id="initial-amount-field"
                    placeholder=""
                    name="initial-amount-field"
                    autocapitalize="off"
                    autocomplete="off"
                    spellcheck="false"
                    aria-label="LABEL HERE"
                    class="form-control cd-rate-amount-input"
                    type="text"
                    @blur="toggleLabel($event)"
                    @focus="toggleLabel($event)"
                    @focusout="minimumRule()"
                    v-model="initialAmountModel"
                    v-mask="currencyMask"
                  />
                </div>
                <!--<div class="cd-rate-calculator-form__error-message" v-show="errored && formSended && !initialAmountModel && !loading &&  initialAmountModel == ''">INITIAL AMOUNT IS REQUIRED</div>-->
                <div class="cd-rate-calculator-form__error-message" v-show="!isMinimumValue">MINIMUM AMOUNT REQUIRED FOR CD IS $500</div>
              </div>
            </div>
          </div>
          <div :class="formInitial || recalculate ? 'row justify-content-center' : 'row'">
            <!-- term length -->
            <div :class="formInitial || recalculate ? 'col-md-6 col-sm-12' : 'col-md-12 col-sm-12'">
              <div class="form-group mb-md-4">
                <div v-if="loadedRateData">
                  <select id="length-field" class="form-control term-length-list" aria-label="term length" v-model="termModel">
                    <option value="default">Term Length</option>
                    <option v-for="(termlength, index) in cdRateData.cdTermLengths" :name="termlength" v-bind:value="{ id: index + 1, text: termlength }" :key="termlength">
                      {{ termlength }}
                    </option>
                    <!-- etc -->
                  </select>
                  <div class="cd-rate-calculator-form__error-message" v-show="errored && formSended && !termModel && !loading">TERM LENGTH IS REQUIRED</div>
                </div>
                <div v-else>
                  <select id="length-field" class="form-control term-length-list" aria-label="term length" v-model="termModel">
                    <!--Added default term lengths for now so its not empty while it does a call to get the term lengths-->
                    <option value="default">Term Length</option>
                    <option name="3 Months" value="3 Months">3 Months</option>
                    <option name="6 Months" value="6 Months">6 Months</option>
                    <option name="12 Months" value="12 Months">12 Months</option>
                    <option name="18 Months" value="18 Months">18 Months</option>
                    <option name="24 Months" value="24 Months">24 Months</option>
                    <option name="30 Months" value="30 Months">30 Months</option>
                    <option name="36 Months" value="36 Months">36 Months</option>
                  </select>
                  <div class="cd-rate-calculator-form__error-message" v-show="errored && formSended && !termModel && !loading">TERM LENGTH IS REQUIRED</div>
                </div>
              </div>
            </div>
          </div>
          <div :class="formInitial || recalculate ? 'row justify-content-center' : 'row'">
            <div :class="formInitial || recalculate ? 'col-md-6 col-sm-12' : 'col-md-12 col-sm-12'">
              <div :class="formInitial || recalculate ? 'form-group d-flex justify-content-center' : 'form-group d-flex justify-content-center justify-content-md-start'">
                <button
                  :class="formInitial || recalculate ? 'btn btn-primary btn-wide btn-pill btn-cd-rate-submit' : 'btn btn-primary btn-wide btn-pill btn-cd-rate-recalc'"
                  type="submit"
                  :disabled="isDisabled"
                >
                  <span class="cta-rate-label" v-if="!loading">{{ formInitial ? "Calculate" : "Re-calculate" }}</span>
                  <div class="cd-rate-calculator-form__loading" v-else>
                    <div class="cd-rate-calculator-form__spinner"></div>
                    Loading...
                  </div>
                </button>
              </div>
              <div class="cd-rate-calculator-form__error-message" v-show="zipErrorForm">A PROBLEM OCCURRED WHILE PROCESSING THE ZIP CODE, PLEASE TRY AGAIN LATER.</div>
            </div>
          </div>
          <div v-show="!formInitial" :class="!formInitial && !recalculate ? 'row cd-rate-disclosure-container' : 'row cd-rate-disclosure-container justify-content-center'">
            <div :class="!formInitial && !recalculate ? 'col-md-12 col-sm-12' : 'col-md-6 col-sm-12'">
              <hr v-show="!formInitial" :class="!formInitial && !recalculate ? 'cd-rate-calculator-form__separator' : 'cd-rate-calculator-form__separator'" />
            </div>
          </div>
          <div v-show="!formInitial" :class="!formInitial && !recalculate ? 'row cd-rate-disclosure-container' : 'row cd-rate-disclosure-container justify-content-center'">
            <div :class="!formInitial && !recalculate ? 'col-md-12 col-sm-12' : 'col-md-6 col-sm-12'">
              <div v-html="disclosure"></div>
            </div>
          </div>
        </div>
        <div v-show="!formInitial && !zipRangeCondition && !zipErrorForm && loadedPercentage" class="col-sm-12 col-md-6 col-lg-6 w-print-lg">
          <div v-if="loadedPercentage" class="row cd-rate-calculator-form__percent my-md-3">
            <div class="col-md-12 d-flex justify-content-center align-items-center">
              <h2 class="fs-5 cd-rate-calculator-form__percent-calc">
                <animated-number :value="apyvalue" :duration="1000" :formatValue="formatToPrice" />
              </h2>
              <div class="cd-rate-calculator-form__percentInfo">
                <div class="cd-rate-calculator-form__percentInfo-sign">%</div>
                <!-- <p class="cd-rate-calculator-form__percentInfo-apy align-self-end">
                  <span>APY</span>
                </p> -->
              </div>
              <h2 class="fs-5 cd-rate-calculator-form__percent-apy">APY</h2>
            </div>
          </div>
          <div :class="loadedPercentage ? 'row pt-md-7' : 'row'">
            <div class="col-md-12">
              <div v-html="disclaimer"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="locations-list">
                <div v-if="loadedLocations" id="location-referrer" class="location-referrer-container row">
                  <div class="col-sm-12 col-md-6" v-for="location in locationData" :name="location.id" :data-locationid="location.id" :key="location.id">
                    <strong
                      ><a :href="location.locationUrl">{{ location.name }}</a></strong
                    ><br />
                    {{ location.address.addressLine1 }}<br />
                    {{ location.address.city }}, {{ location.address.state }} {{ location.address.zip }}<br /><br />
                  </div>
                </div>
                <div v-else>
                  <div v-if="loadingLocations" class="cd-rate-calculator-form__loading py-md-2">
                    <div class="cd-rate-calculator-form__spinner"></div>
                    Loading...
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div :class="isIOSorAndroid ? 'd-none' : 'row d-none d-lg-block d-xl-block'">
            <div class="col-md-12">
              <div class="form-group">
                <button class="btn btn-primary btn-wide btn-pill btn-cd-rate-recalc" @click="printWindow()" type="button">
                  <span class="cta-rate-label">Print Rate</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import axios from "axios"
import * as VueGoogleMaps from "vue2-google-maps"
import Vue from "vue"
import VueMq from "vue-mq"
import { googleApi } from "../../../config/map"
import { gmapApi } from "vue2-google-maps"
import AnimatedNumber from "animated-number-vue"
import createNumberMask from "text-mask-addons/dist/createNumberMask"
Vue.use(VueGoogleMaps, {
  load: {
    key: googleApi.geoKey,
    v: "3.40"
  },
  installComponents: false
})
// these are max widths of breakpoints
Vue.use(VueMq, {
  breakpoints: {
    mobile: 767,
    tablet: 991,
    desktop: Infinity
  }
})

export default {
  data() {
    return {
      cdRateData: null,
      cdRateRange: null,
      errored: false,
      locationData: null,
      closestLocation: null,
      index: 0,
      loading: false,
      loadingLocations: false,
      showDefault: false,
      loaded: false,
      loadedLocations: false,
      loadedRateData: false,
      radius: 5,
      zipcodeModel: "",
      initialAmountModel: "",
      termModel: "default",
      formSended: false,
      formInitial: true,
      zipRangeCondition: false,
      zipErrorForm: false,
      apyvalue: 0.0,
      loadedPercentage: true,
      recalculate: false,
      termLength: "",
      allowLocationStop: false,
      axiosCancelSource : axios.CancelToken.source(),
      zipCodeLessThanFive : false,
      isMinimumValue : true,
      currencyMask: createNumberMask({
        prefix: "$",
        includeThousandsSeparator: true,
        allowNegative: false,
        thousandsSeparatorSymbol: ",",
        allowDecimal: true,
        decimalSymbol: "."
      })
    }
  },
  components: {
    AnimatedNumber
  },
  mounted() {
    if (this.zipcode) {
      this.zipcodeModel = this.zipcode
      this.initialAmountModel = this.initialAmount
      this.getInitialLocationData()
    } else {
      // use browser geolocation lat and long if no data
      this.allowLocation()
      //this.showDefault = true
    }
  },
  computed: {
    isMobile() {
      return this.$mq != "desktop"
    },
    isIOSorAndroid () {
      if (/iPad|iPhone|iPod/.test(navigator.userAgent) || /(android)/i.test(navigator.userAgent)) {
        return true;
      } else {
        return navigator.maxTouchPoints &&
          navigator.maxTouchPoints > 2 &&
          /MacIntel/.test(navigator.platform);
      }
    },
    google: gmapApi,
    isDisabled() {
      let amount = this.convertStringToNumber
      let condition = !this.zipCodeLessThanFive && this.zipcodeModel && Boolean(amount) && this.isMinimumValue && this.termModel && this.termModel !== "default"
      if (condition) {
        return false
      } else {
        return true
      }
    },
    convertStringToNumber() {
      let amount = this.initialAmountModel && this.initialAmountModel.replace("$", "").replace(/,/g,'')
      return amount
    }
  },
  methods: {
    printWindow: function () {
      window.print()
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault()
      }
    },
    formatToPrice(value) {
      return `${value.toFixed(2)}`
    },
    //step 2: previews send the form data
    async getLocations(radius, lat, long) {
      this.loaded = false
      let locationApi = "/api/locations?lat=" + lat + "&lng=" + long + "&radius=" + radius + "&includeAssociateOnly=false&includeAtms=false"
      this.loadingLocations = true
      if (this.allowLocationStop == false)
      {
        axios
        .get(locationApi, { cancelToken: this.axiosCancelSource.token })
        .then((response) => {
          this.loadingLocations = false
          this.locationData = response.data.locations || []
          this.loadedLocations = true
          // check for data
          if (this.locationData.length <= 0) {
            this.errored = true
            this.loadedLocations = false

            if (radius == "10" && this.allowLocationStop == false) {
              radius = 20
              this.getLocations(radius, lat, long)
            }

            if (radius == "5" && this.allowLocationStop == false) {
              radius = 10
              this.getLocations(radius, lat, long)
            }
          }
          else if (this.locationData.length > 0) {
            this.axiosCancelSource.cancel('Component unmounted.')
            this.axiosCancelSource = axios.CancelToken.source();
            this.allowLocationStop = true;
            this.closestLocation = this.locationData[0]
            this.getLocationRateData(this.closestLocation.id)
            if (this.zipcode == "") {
              this.zipcodeModel = this.closestLocation.address.zip
            }
          }
        })
        .catch((error) => {
          this.errored = true
        })
      }  
    },
    //step 3: previews send the form data
    async getLocationRateData(branchID) {
      let cdRatesApi = "/api/location-rates?id=" + branchID

      axios
        .get(cdRatesApi)
        .then((response) => {
          this.cdRateData = response.data
          this.cdRateRange = response.data.cdDepositTiers
          //this.showDefault = false
          this.loadedRateData = true
          if (this.cdRateData?.cdTermLengths?.length <= 0 || this.cdRateData?.cdDepositTiers?.length <= 0 || this.cdRateData?.cdRegionalRates?.length <= 0) {
            this.errored = true
            this.showDefault = true
            this.loadedRateData = false
          }
        })
        .catch((error) => {
          this.errored = true
        })
    },
    async getCDRates() {
      this.loading = true
      this.loadingLocations = true
      this.formSended = true
      this.termLength = this.termModel.text
      if (typeof this.termModel.text === "undefined") {
        this.termLength = this.termModel
      }
      let amount = this.convertStringToNumber
      if (this.zipcodeModel && Boolean(amount) && amount > 0 && this.termModel && this.termModel !== "default") {
        try {
          window
            .HERO_analytics_rate_calculator
            .trackCalculateEvent(this.formInitial ? "Calculate" : "Re-calculate", this.zipcodeModel, this.convertStringToNumber, this.termLength)
        } catch (e) {}
        setTimeout(() => {
          this.loadCdRate()
          this.loading = false
        }, 2000)
      } else {
        this.errored = true
        this.formSended = true
        this.loading = false
      }
    },
    updateZipCode() {
      this.loadedPercentage = false
      this.allowLocationStop = false
      this.getInitialLocationData()
    },
    minimumRule() {
      let amount = this.convertStringToNumber
      if(amount > 499 ) {
        this.isMinimumValue = true
      }
      else {
        this.loadedPercentage = false
        this.isMinimumValue = false
      }
    },
    clearInput(){
      this.zipRangeCondition = false
      this.zipErrorForm = false
    },
    loadCdRate() {
      this.zipRangeCondition = false
      this.zipErrorForm = false
      if (!this.loadedLocations) {
        this.loadingLocations = false
        this.errored = true
        this.zipRangeCondition = this.formSended && Boolean(this.zipcodeModel) && this.errored
        this.recalculate = !this.formInitial && this.zipRangeCondition
        return
      }
      if (!this.loadedRateData || !this.locationData || this.cdRateRange.length <= 0) {
        this.errored = true
        this.loadingLocations = false
        if (!this.loadedRateData || this.cdRateRange.length <= 0) {
          this.zipErrorForm = !this.loadedRateData && this.formSended && this.errored
          this.recalculate = !this.formInitial && this.zipErrorForm
          return
        }
      }
      this.errored = false
      this.formInitial = false
      this.recalculate = false
      let amount = this.convertStringToNumber
      const range = this.getAmountGroup(amount, this.cdRateRange)

      if (range != null) {

        // subtract 1 from term model value, array was 1 through 7, need 0 through 6
        let termLengthValue = this.termModel.id - 1
        this.loadedPercentage = true
        // deposit Tier Value has to be a function to check which teir the amount is in, needs to return 1,2,3,4 or 5
        let depositTierValue = range
        let depositTierTotalCount = this.cdRateRange.length
        // termLengthValue = tl = 0 thur 6
        // depositTierValue = dt = 1 thru 5
        // depositTierCount = dtc = 5
        //
        // to get position in rates array, multiply term length value by deposit tier total count plus the deposit tier value
        // pos = ( tl x dtc ) + dt
        // pos = ( 0 x 5 ) + 1 = 1
        // pos = ( 1 x 5 ) + 1 = 6
        // pos = ( 4 x 5 ) + 3 = 23
        // pos = ( 6 x 5 ) + 5 = 35
        //
        // subtract one from position, array starts at index 0
        // apy = this.cdRateData.cdRegionalRates[ pos - 1 ]
        // apy[0] = 0.0005
        // apy[5] = 0.001
        // apy[22] = 0.002
        // apy[34] = 0.003
        this.loadingLocations = false
        let apyPosition = termLengthValue * depositTierTotalCount + (depositTierValue - 1)
        this.apyvalue = this.cdRateData.cdRegionalRates[apyPosition] * 100
      }
    },
    getAmountGroup(amount, amountArray) {
      let rangeResult = null
      for (let index = 0; index < amountArray.length; index++) {
        const element = amountArray[index]
        let myArray = element.split("-")
        let range
        let min = parseInt(myArray[0])
        let max = parseInt(myArray[1])

        if (max) {
          range = this.inRange(amount, min, max)
        } else {
          range = amount >= min && true
        }

        if (range) {
          const results = index + 1
          rangeResult = results
        }
      }
      return rangeResult
    },
    inRange(x, min, max) {
      const result = x >= min && x <= max
      return result
    },
    //step 1(after mount): previews send the form data
    async getInitialLocationData() {
      this.errored = false
      let inputValue = this.zipcodeModel
      this.loadedLocations = false
      //let latitude = ''
      //let zipcodeBlockDefault = document.getElementById('zipcode-identifier-block')
      if (!inputValue) {
        this.errored = true
        this.zipCodeLessThanFive = true
        // advisorsBlockDefault.classList.add('default-advisors-active')
      } else {
        if (inputValue.length == 5 && !isNaN(inputValue)) {
          this.zipCodeLessThanFive = false
          var _ = this
          let longitude = ""
          let latitude = ""
          _.$gmapApiPromiseLazy().then(() => {
            let geocoder = new _.google.maps.Geocoder()
            geocoder.geocode({ address: "zipcode " + inputValue }, (results, status) => {
              if (status == _.google.maps.GeocoderStatus.OK) {
                this.loadingLocations = true
                latitude = results[0].geometry.location.lat()
                longitude = results[0].geometry.location.lng()
                this.getLocations(this.radius, latitude, longitude)
                
                return results
              } else {
                this.errored = false
              }
            })
          })
        } else {
          this.zipCodeLessThanFive = true
          this.errored = true
        }
      }
    },
    validateNumber(event) {
      let keyCode = event.keyCode
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault()
      }
    },
    validateNumberMobile(event) {
      event.target.value = event.target.value.replace(/[^\d]/g, "")
      return false
    },
    async allowLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            let payload = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
            //this.latitude = payload.lat;
            //this.longitude = payload.lng;
            this.getLocations(this.radius, payload.lat, payload.lng)
          },
          (err) => {
            console.error("User did not allow geolocation")
            console.error(err)
          }
        )
      }
    },
    toggleLabel(event) {
      if (event.type === "focus") {
        // For IE support, keep the following add() methods separate
        event.target.parentElement.classList.add("has-focus")
        event.target.parentElement.classList.add("is-floating")
      }
      if (event.type === "blur") {
        event.target.parentElement.classList.remove("has-focus")
        if (event.target.value === "") {
          event.target.parentElement.classList.remove("is-floating")
        }
      }
    }
  },
  props: {
    zipcode: String,
    longitude: String,
    latitude: String,
    disclaimer: String,
    disclosure: String
  },
  watch: {}
}
</script>
